import { CtaBand } from "../components/CtaBand";
import { DevicesSection } from "../components/DevicesSection";
import { HowItWorks } from "../components/HowItWorks";
import { PageHeader } from "../components/PageHeader";

export function HowItWorksPage() {
  return (
    <>
      <PageHeader
        eyebrow="How it works"
        title="Three steps to get your family started"
        lead="We're welcoming families in gradually, so every request is read by a real person."
      />
      <div className="container page-body">
        <HowItWorks />
      </div>
      <DevicesSection />
      <CtaBand />
    </>
  );
}
